// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-1-3!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-4!../../node_modules/sass-loader/dist/cjs.js??ref--6-oneOf-1-5!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./_slug.vue?vue&type=style&index=0&id=e4b7dc50&lang=sass&scoped=true&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("449ff000", content, true, {"sourceMap":false});